// © Microsoft Corporation. All rights reserved.
/** App id for Homepage app in Super app */
export const homepageAppId = "0067acd6d05f4168b92f510d33b9ed74";
/** App id for Following app in Super app */
export const followingAppId = "dc6cfb18912240efaa3557c0123fb1eb";
/** App id for the Rewards mini App */
export const rewardsMiniAppId = "32649384730b2d61c9e79d46de589115";
/** 1s user scope */
export const apiUserScope = "service::api.msn.com::MBI_SSL";
/** 1s user scope for Bing/Start App */
export const apiUserScopeV2 = "service::www.msn.com::MBI_SSL";
/** Scope Id for feed on Edge mobile */
export const OAuthV2ScopeId = "api://www.msn.com/OneService.Read";
export const cachedDigitalIdKey = "DIGITAL_ID_KEY";
//# sourceMappingURL=Constants.js.map